/**
 * SEO & AI Meta Tags Utility for Terry Land
 * Handles dynamic document.title, meta descriptions, Open Graph, Twitter cards, and Schema.org JSON-LD.
 */

const DEFAULT_KEYWORDS =
  "برانص, برانص حمام, برنس حمام رجالي, برنس حمام حريمي, برنس عرايس, أرواب حمام فاخرة, فوط, فوط حمام, بشاكير, بشكير حمام, أطقم فوط, عرائس, جهاز العروسة, تجهيز عرائس, مفروشات عرايس, أطقم عرايس, مايكروفايبر, قطن, خامة الوجهين, تيري لاند, Terry Land, luxury bathrobes, hotel towels, bath sheets, bridal linens, bridal trousseau, microfiber cotton";

const DEFAULT_IMAGE = "https://terryland.net/logo512.png";

export function updateSEO({
  title,
  description,
  keywords = DEFAULT_KEYWORDS,
  canonical,
  ogType = "website",
  ogImage = DEFAULT_IMAGE,
  jsonLd,
}) {
  if (typeof document === "undefined") return;

  // 1. Update Title
  if (title) {
    document.title = title;
  }

  const setMeta = (attr, key, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  // 2. Standard Meta Tags
  if (description) {
    setMeta("name", "description", description);
  }
  if (keywords) {
    setMeta("name", "keywords", keywords);
  }

  // 3. Open Graph Tags
  if (title) {
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
  }
  if (description) {
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:description", description);
  }
  if (ogType) {
    setMeta("property", "og:type", ogType);
  }
  if (ogImage) {
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:image", ogImage);
  }
  if (canonical) {
    setMeta("property", "og:url", canonical);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }

  // 4. Dynamic Schema.org JSON-LD
  if (jsonLd) {
    let script = document.getElementById("page-dynamic-jsonld");
    if (!script) {
      script = document.createElement("script");
      script.id = "page-dynamic-jsonld";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonLd);
  }
}
